"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = exports.Overlay = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.Overlay = native_1.default.View `
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 12px 24px;
`;
exports.Modal = native_1.default.View `
  width: 100%;
  ${({ maxWidth }) => !!maxWidth && `max-width: ${maxWidth};`}
  max-height: 100%;
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 0;
`;
